import React from "react";

import { Login } from "../Login/Login";

import "./Main.css"

export const Main = () => {
    return (
        <div className="main-container">
            <Login />
        </div>
    )
}


